module.exports = __webpack_public_path__ + "assets/img/step4-sz.f3721608.png";